import "./OurServices.css";
import { GoArrowRight } from "react-icons/go";
import { useState, useEffect ,useRef} from "react";

import Slideimg1 from "../../assets/images/service1img.png";
import Slideimg2 from "../../assets/images/sliderimg2.png";
import Slideimg3 from "../../assets/images/sliderimg3.png";
import serviceLogo from "../../assets/logos/ServiceLogo.svg";
import Button from "../Button/Button";
import { useNavigate } from "react-router-dom";


function OurServicesSection({ sectionId }) {
   const navigate = useNavigate();



    const handleSearchExperts = () => {
    navigate('/counsellor');
  };
  const services = [
    {
      number: "01",
      img: Slideimg1,
      heading1: "Kickstart your career with the right",
      heading2: "Job or Internship",
      description:
        "Explore over 5 lakh verified opportunities across top companies and industries—tailored just for students and freshers.",
      text: "SEARCH JOB",
      route: "/jobs"
    },
    {
      number: "02",
      img: Slideimg2,
      heading1: "Choose the best career path",
      heading2: "with Experts",
      description:
        "Find out newest industry programs, workshops, news, and community activities.",
      text: "EXPLORE PROGRAMS",
      route: "/counsellor"
    },
    {
      number: "03",
      img: Slideimg3,
      heading1: "Empower students by becoming a",
      heading2: "Trusted Counsellor",
      description:
        "Share your expertise and guide the next generation of students and professionals toward meaningful career paths.",
      text: "EXPLORE NOW",
      route: "https://play.google.com/store/apps/details?id=com.riso.counsellor"
    },
  ];

  const [activeSlide, setActiveSlide] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);
 

  useEffect(() => {
    setAnimationKey((prevKey) => prevKey + 1);
  }, [activeSlide]);

  // // ✅ AUTO SLIDE
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev === services.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <section className="our-service" id={sectionId}>
         <svg
          key={animationKey}
          className="service-curve-line"
          viewBox="0 0 200 700"
          preserveAspectRatio="none"
        >
          <path
            d="M 0 80 Q 220 300 140 700"
            fill="none"
            stroke="#D3D3D3"
            strokeWidth="1"
            className="curve-path"
          />
        </svg>

             <svg
          key={`right-${animationKey}`}
          className="service-curve-line-right"
          viewBox="0 0 300 700"
          preserveAspectRatio="none"
        >
          <path
            d="M 300 70 Q 120 560 300 700"
            fill="none"
            stroke="#D3D3D3"
            strokeWidth="1"
            className="curve-path"
          />
        </svg>

          <svg
          key={`right1-${animationKey}`}
          className="service-curve-line-right1"
          viewBox="0 0 300 700"
          preserveAspectRatio="none"
        >
          <path
            d="M 300 550 Q 120 550 300 800"
            fill="none"
            stroke="#D3D3D3"
            strokeWidth="1"
            className="curve-path"
          />
        </svg>
        
        <div className="title-section">
          <img src={serviceLogo} alt="logo"></img>
          <h2 className="title-text">
            Our <span>Services</span>
          </h2>
          <div className="underline"></div>
        </div>
        <div className="Service-1-section">

          {services.map((item, index) => (
            <div
              key={index}
              className="service1-container"
              style={{
                display: index === activeSlide ? "flex" : "none",
              }}
            >
              {/* LEFT CONTENT */}
              <div className="service-1-info">
                <div
                  className={`service-1-num ${
                    index === activeSlide ? "num-animate" : ""
                  }`}
                >
                  <h1 className="num-1">{item.number}</h1>
                </div>

                <div
                  className={`service-1-details-container ${
                    index === activeSlide ? "details-animate" : ""
                  }`}
                >
                  <div className="service-1-details">
                    <div className="service-1-heading">
                      <h1 className="heading-1">{item.heading1}</h1>
                      <h1 className="heading-2">{item.heading2}</h1>
                    </div>

                    <p>{item.description}</p>

                  <div className="service-1-btn">
                     <Button 
                  variant="teal" 
                  showArrow={true}
                  className="faq-contact-btn"
                     onClick={() => {
    if (item.route.startsWith("http")) {
      window.open(item.route, "_blank");
    } else {
      navigate(item.route); 
    }
  }}
                >
                  {item.text}
                </Button>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT IMAGE */}
              <div
                className={`service-1-img ${
                  index === activeSlide ? "img-animate" : ""
                }`}
              >
                <img src={item.img} alt="service" />
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default OurServicesSection;